module.exports = __webpack_public_path__ + "img/dagger_6.7adf66ec.png";